import { render, staticRenderFns } from "./AdicionalIndex.vue?vue&type=template&id=7b0982c0"
import script from "./AdicionalIndex.vue?vue&type=script&lang=js"
export * from "./AdicionalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports